import type { User } from '@/types/auth';
import { deleteCookie, getCookie, setCookie } from '../utils/cookie';

// KEEP IN MIND IF SERVER SIDE SENDS COOKIE AS HTTPONLY - YOU CAN"T ACCESS IT VIA JS/TS
export class CookieConst {
  public static RCReadOnlyUser = "RCReadOnlyUser"
}

export interface AuthStorage {
  getItem: (key: string) => string | null;
  removeItem: (key: string) => void;
  setItem: (key: string, value: string, expires: Date | undefined) => void;
  getUser: () => Promise<User | null>;
  setUser: (user: User) => Promise<void>;
  removeUser: () => Promise<void>;
  removeYsiSessionID: () => Promise<void>;
}

// Web-specific storage implementation using cookies for tokens
export const webStorage: AuthStorage = {
  getItem(key: string): string | null {
    const value = getCookie(key);
    return value || null;
  },
  removeItem(key: string): void {
    deleteCookie(key);
  },
  setItem(key: string, value: string, expires: Date | undefined): void {
    setCookie(key, value, { expires });
  },
  async getUser() {
    try {
      const userStr = localStorage.getItem('user');
      console.log('🔍 webStorage.getUser:', userStr ? 'FOUND' : 'NOT FOUND');
      return userStr ? JSON.parse(userStr) as User : null;
    } catch (error) {
      console.error('❌ webStorage.getUser failed:', error);
      return null;
    }
  },
  async setUser(user: User) {
    try {
      console.log('💾 webStorage.setUser: Storing user:', user.email);
      const userStr = JSON.stringify(user);
      localStorage.setItem('user', userStr);
      // Verify it was actually stored
      const verify = localStorage.getItem('user');
      if (!verify) {
        throw new Error('User verification failed after storage');
      }
      console.log('✅ webStorage.setUser: User stored and verified');
    } catch (error) {
      console.error('❌ webStorage.setUser failed:', error);
      throw error;
    }
  },
  async removeUser() {
    try {
      console.log('🗑️ webStorage.removeUser: Removing user');
      localStorage.removeItem('user');
    } catch (error) {
      console.error('❌ webStorage.removeUser failed:', error);
    }
  },
  async removeYsiSessionID() {
    try {
      console.log('🗑️ webStorage.removeYsiSessionID: Clearing session cookie');
      document.cookie = `YSISessionID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    } catch (error) {
      console.error('❌ webStorage.removeYsiSessionID failed:', error);
    }
  }
}; 